<template>

  <div>
     <KTCodePreview v-bind:title="'Danh sách quyền'"
      > <template v-slot:toolbar
        >
        <div class="row">
           <router-link
            to="/permissions/upsert-permission"
            v-show="activeTab === 0 && checkPermission(listPermission, 'ROLE_INSERT')"
          >
            <button
              v-bind:style="{ fontWeight: '600!important' }"
              type="button"
              class="btn btn-primary btn-sm"
            >
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>Tạo quyền
            </button>
          </router-link>
        </div>
      </template>

      <template v-slot:preview>
        <b-tabs v-model="activeTab" content-class="pt-5" nav-class="border-bottom">
          <b-tab title="Phân quyền theo vai trò">
            <PermissionTab />
          </b-tab>
          <b-tab title="Giới hạn ngày xem/xuất Excel/chỉnh sửa theo chức vụ">
            <DayLimitTab />
          </b-tab>
        </b-tabs>
      </template>
    </KTCodePreview>
  </div>

</template>

<style>
  .icon:hover {
  background-color: #90c6fc;
}

.sttClass {
  width: 6%;
}
.codeClass {
  width: 40%;
}
.nameClass {
  width: 40%;
}

.table-active {
  background-color: #f8f9fa !important;
  border-left: 4px solid #007bff !important;
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { mapGetters } from 'vuex';
import { checkPermission } from '@/utils/permission';
import PermissionTab from './PermissionTab.vue';
import DayLimitTab from './DayLimitTab.vue';

export default {
  components: {
    KTCodePreview,
    PermissionTab,
    DayLimitTab,
  },
  data() {
    return {
      activeTab: this.$route.query.tab === 'day-limit' ? 1 : 0,
    };
  },
  computed: {
    ...mapGetters(['listPermission']),
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phân quyền', route: '/permissions' },
      { title: 'Danh sách quyền' },
    ]);
    console.log('ListPermission mounted, tab:', this.$route.query.tab, 'activeTab:', this.activeTab);
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        if (newTab === 'day-limit') {
          this.activeTab = 1;
        } else {
          this.activeTab = 0;
        }
      },
      immediate: true
    }
  },
  methods: {
    checkPermission,
  },
};
</script>

